<template>
   <gat-form>
      <gat-group title="Budsjett avvik" :collapsed="false">
         <v-layout wrap>
            <gat-grid :columns="topCatCols" :items="topCategoryAmounts" @row-clicked="showAccountDash" />
         </v-layout>
      </gat-group>
   </gat-form>
</template>

<script>
import GatGroup from "@/GatComponents/GatGroup.vue";
import GatForm from "@/GatComponents/GatForm.vue";
import GatGrid from "@/GatComponents/GatGrid.vue";
import numeral from "numeral";

import { apiPost } from "@/dal";
export default {
   name: "Dashboard",
   props: [],
   components: { GatGroup, GatForm, GatGrid },
   data: function () {
      return {
         topCategoryAmountsLastyear: [],
         topCategoryAmountsTwoYearsAgo: [],
         topCatCols: [
            { header: "Category", field: "Cat1" },
            { header: "Total", field: "Amount", dataType: "number", format: "Kr 0,0" },
            { header: "Budget", field: "Budget", dataType: "number", format: "Kr 0,0" },
            {
               header: "Per month",
               dataType: "number",
               format: "Kr 0,0",
               calculated: (rowData) => {
                  let monthAmount = rowData.Amount / 12.0;
                  let result = numeral(monthAmount).format("Kr 0,0");
                  if (monthAmount < rowData.Budget * 1.1) {
                     result = '<span class="red--text">' + result + "</span>";
                  } else if (rowData.Budget < monthAmount * 1.1) {
                     result = '<span class="blue--text">' + result + "</span>";
                  } else {
                     result = '<span class="green--text">' + result + "</span>";
                  }
                  return result;
               },
            },
            {
               header: "1 year ago",
               dataType: "number",
               format: "Kr 0,0",
               calculated: (rowData) => {
                  let result = null;
                  if (this.topCategoryAmountsLastyear.length > 0) {
                     let oldItem = this.topCategoryAmountsLastyear.find((item) => {
                        return item.Cat1 == rowData.Cat1;
                     });
                     if (oldItem) {
                        result = numeral(oldItem.Amount / 12.0).format("Kr 0,0");
                     }
                  }
                  return result;
               },
            },
            {
               header: "2 year ago",
               dataType: "number",
               format: "Kr 0,0",
               calculated: (rowData) => {
                  let result = null;
                  if (this.topCategoryAmountsTwoYearsAgo.length > 0) {
                     let oldItem = this.topCategoryAmountsTwoYearsAgo.find((item) => {
                        return item.Cat1 == rowData.Cat1;
                     });
                     if (oldItem) {
                        result = numeral(oldItem.Amount / 12.0).format("Kr 0,0");
                     }
                  }
                  return result;
               },
            },
            {
               header: "avg last 36 months",
               dataType: "number",
               format: "Kr 0,0",
               calculated: (rowData) => {
                  let result = null;
                  if (this.topCategoryAmountsLast36Months.length > 0) {
                     let oldItem = this.topCategoryAmountsLast36Months.find((item) => {
                        return item.Cat1 == rowData.Cat1;
                     });
                     if (oldItem) {
                        result = numeral(oldItem.Amount / 36.0).format("Kr 0,0");
                     }
                  }
                  return result;
               },
            },
         ],
      };
   },

   created() {
      if (this.$store.state.topCategoryAmounts.length == 0) {
         this.refreshAmounts();
      }

      if (this.topCategoryAmountsLastyear.length == 0) {
         this.refreshTopCategoryAmountsLastyear();
      }
      if (this.topCategoryAmountsTwoYearsAgo.length == 0) {
         this.refreshTopCategoryAmountsTwoYearsAgo();
      }
   },

   computed: {
      topCategoryAmounts() {
         return this.$store.state.topCategoryAmounts;
      },
      topCategoryAmountsLast36Months() {
         let result = [];
         this.topCategoryAmounts.map((orgItem) => {
            let newItem = { Cat1: orgItem.Cat1, Amount: orgItem.Amount };
            let otherItem = this.topCategoryAmountsTwoYearsAgo.find((item) => {
               return item.Cat1 == orgItem.Cat1;
            });
            if (otherItem) {
               newItem.Amount = newItem.Amount + otherItem.Amount;
            }
            otherItem = this.topCategoryAmountsLastyear.find((item) => {
               return item.Cat1 == orgItem.Cat1;
            });
            if (otherItem) {
               newItem.Amount = newItem.Amount + otherItem.Amount;
            }

            result.push(newItem);
         });
         return result;
      },
   },

   mounted() {
      if (this.$store.state.expectedTransactions.length == 0) {
         this.$store.dispatch("getExpectedTransactions");
      }
   },

   watch: {},

   methods: {
      showAccountDash(rowData) {
         console.log("showAccountDash", rowData);
      },
      refreshAmounts() {
         let fromDate = new Date();
         fromDate = fromDate.setDate(fromDate.getDate() - 365);
         apiPost("db/get/topcategoryamounts", { fromDate: fromDate, toDate: new Date() })
            .then((data) => {
               data = data.filter((item) => {
                  return (
                     item.Cat1 != "Ignorer" &&
                     item.Cat1 != "Sparing" &&
                     item.Cat1 != "Store kjøp uten budsjett" &&
                     item.Cat1 != "Inntekt"
                     //  item.Cat1 != "Ferie og Reiser"
                  );
               });
               let totalAmount = 0;
               let totalBudget = 0;
               data.map((item) => {
                  totalAmount = totalAmount + item.Amount;
                  totalBudget = totalBudget + item.Budget;
               });
               console.log("data", data);
               let total = { Cat1: "Totalt", Amount: totalAmount, Budget: totalBudget };
               data.push(total);
               this.$store.commit("setTopCategoryAmounts", data);
            })
            .catch(() => {});
      },
      refreshTopCategoryAmountsLastyear() {
         let fromDate = new Date();
         let toDate = new Date();
         fromDate = fromDate.setDate(fromDate.getDate() - 2 * 365);
         toDate = toDate.setDate(toDate.getDate() - 365);
         apiPost("db/get/topcategoryamounts", { fromDate: fromDate, toDate: toDate })
            .then((data) => {
               this.topCategoryAmountsLastyear = data;
            })
            .catch(() => {});
      },
      refreshTopCategoryAmountsTwoYearsAgo() {
         let fromDate = new Date();
         let toDate = new Date();
         fromDate = fromDate.setDate(fromDate.getDate() - 3 * 365);
         toDate = toDate.setDate(toDate.getDate() - 2 * 365);
         apiPost("db/get/topcategoryamounts", { fromDate: fromDate, toDate: toDate })
            .then((data) => {
               this.topCategoryAmountsTwoYearsAgo = data;
            })
            .catch(() => {});
      },
   },
};
</script>

<style scoped></style>
